const routes = [
  {
    path: '/authentication',
    component: () => import('layouts/Auth.vue'),
    children: [
      { path: '', name: 'Authentication', component: () => import('pages/Authentication.vue') },
      { path: 'recover/:id/:token', name: 'RecoverAccount', component: () => import('pages/accounts/Recover.vue') },
    ],
  },

  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true },
    children: [
      { path: '', name: 'Home', component: () => import('pages/Index.vue') },
    ],
  },

  {
    path: '/products',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true },
    children: [
      { path: 'extras', name: 'ExtrasHome', component: () => import('pages/products/Extras.vue') },
      { path: 'new-cars', name: 'NewCarsHome', component: () => import('pages/products/NewCars.vue') },
      { path: 'used-cars', name: 'UsedCarsHome', component: () => import('pages/products/UsedCars.vue') },
      { path: 'view/:id', name: 'ProductView', component: () => import('pages/products/View.vue') },
      { path: 'text-copy/:id', name: 'ProductTextCopy', component: () => import('pages/products/TextCopy.vue') },
      { path: 'history', name: 'HistoryHome', component: () => import('pages/products/History.vue') },
    ],
  },

  {
    path: '/models',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true },
    children: [
      { path: '', name: 'ModelsHome', component: () => import('pages/models/Index.vue') },
      { path: 'view/:id', name: 'ModelView', component: () => import('pages/models/View.vue') },
    ],
  },

  {
    path: '/categories',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true },
    children: [
      { path: '', name: 'CategoriesHome', component: () => import('pages/categories/Index.vue') },
      { path: 'create', name: 'CategoryCreate', component: () => import('pages/categories/Create.vue') },
      { path: 'view/:id', name: 'CategoryView', component: () => import('pages/categories/View.vue') },
    ],
  },

  {
    path: '/bookings',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true, needsBooking: true },
    children: [
      { path: '', name: 'BookingsHome', component: () => import('pages/bookings/Index.vue') },
    ],
  },

  {
    path: '/accounts',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true, needsSuperAdmin: true },
    children: [
      { path: '', name: 'AccountsHome', component: () => import('pages/accounts/Index.vue') },
      { path: 'create', name: 'AccountCreate', component: () => import('pages/accounts/Create.vue') },
      { path: 'view/:id', name: 'AccountView', component: () => import('pages/accounts/View.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;
